import { useGetCheckApprovedByTypeQuery } from '@/hooks/qna/qna.gql.impl';
import { AgreementCategory, AgreementType } from '@/types/bff/gql-schema';

interface Props {
  category: AgreementCategory;
  type: AgreementType;
}

const useGetCheckApprovedByType = ({ category, type }: Props) => {
  const { data } = useGetCheckApprovedByTypeQuery(
    {
      request: {
        agreementCategory: category, // FIXME 카테고리랑 타입 수정하기
        agreementType: type,
      },
    },
    { select: (response) => response.checkApprovedByType },
  );

  return { data };
};
export default useGetCheckApprovedByType;
